import { Component, inject } from '@angular/core';
import { DeveloperService } from "@core/services/developer.service";
import { IonicModule } from "@ionic/angular";
import { collapseAnimations } from "@shared/animations/collapse.animations";

@Component({
  selector: 'pkp-log-panel',
  templateUrl: './log-panel.component.html',
  styleUrls: ['./log-panel.component.scss'],
  standalone: true,
  imports: [
    IonicModule
  ],
  animations: [collapseAnimations]
})
export class LogPanelComponent {
  readonly developerService = inject(DeveloperService);

  logs = this.developerService.logs;
  isOpen = this.developerService.logsVisible;

}
